import React, {Component} from 'react';
import Modal from 'react-modal';
import {IconExclamationAlt, IconX, Type} from '@spotify-internal/encore-web';

import {notificationPropType} from 'utils/custom-proptypes';

import styles from './NotificationModal.module.scss';

class NotificationModal extends Component {
  static propTypes = {
    notification: notificationPropType,
  };

  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
    };
  }

  closeModal = () => {
    this.setState({showModal: false});
  };

  render() {
    const notification = this.props.notification;

    return (
      <Modal
        isOpen={this.state.showModal}
        onRequestClose={this.closeModal}
        overlayClassName={styles.overlay}
        className={styles.content}
        shouldCloseOnOverlayClick>
        <button className={styles.close} onClick={this.closeModal}>
          <IconX aria-label="IconClose" iconSize={24} />
        </button>
        <IconExclamationAlt className={styles.icon} iconSize={64} />
        <div className={styles.infoText}>
          <Type.p variant={Type.body1} dangerouslySetInnerHTML={{__html: notification.body}} />
          <p className={styles.date}>{notification.lastUpdated}</p>
        </div>
      </Modal>
    );
  }
}

export default NotificationModal;
